import React, {
  AnchorHTMLAttributes,
  DetailedHTMLProps,
  forwardRef,
  Ref,
  useState,
} from 'react';
import classNames from 'classnames';
import { FontStyleEnums } from '@oy/uicore';
import { Text } from '../../Contents';
import styles from './Link.module.css';

enum LinkUnderlineStyle {
  default,
  noUnderline,
}

type LinkProps = {
  linkUnderlineStyle?: LinkUnderlineStyle;
  linkStyle: FontStyleEnums;
} & DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
>;

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  (
    {
      linkUnderlineStyle = LinkUnderlineStyle.default,
      linkStyle,
      className,
      children,
      ...props
    }: LinkProps,
    ref: Ref<HTMLAnchorElement>,
  ) => {
    const [isPressed, setIsPressed] = useState(false);

    const eventClasses = classNames({
      [styles.pressed]: isPressed,
    });

    const handleMouseDown = () => {
      setIsPressed(true);
    };
    const handleMouseUp = () => {
      setIsPressed(false);
    };

    return (
      <a
        {...props}
        ref={ref}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        className={classNames(
          linkUnderlineStyle === LinkUnderlineStyle.noUnderline
            ? styles.linkNoUnderline
            : styles.link,
          eventClasses,
          className,
        )}
      >
        <Text textStyle={linkStyle} tag="span">
          {children}
        </Text>
      </a>
    );
  },
);

export default Object.assign(Link, {
  Style: FontStyleEnums,
  UnderlineStyle: LinkUnderlineStyle,
});
